// TODO :( use a flamethrower (we need good tooltips)
import { EnumerationBuilder } from 'utility-js-enumeration';
export const DevelopmentalEnum = EnumerationBuilder.useDefinitionAsValue('DevelopmentalEnum', {
  ID: 'developmental',
  TITLE: 'Developmental Courses',
  ELEMENTS: {
    DESC: {
      template:
        '<p class="text text-bold">You should take these courses first to be eligible to take your program courses.</p><p class="text">Developmental courses prepare you for college level coursework. These courses do not count toward your degree requirements and will add time in school.</p>'
    },
    EXPL: { template: 'Each <i class="eab-icon-book blue"></i> represents 1 course needed.' }
  }
} as any);
angular.module('capability-ng-academic-planner').constant('DevelopmentalEnum', DevelopmentalEnum);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/types/developmental_enum.ts